// 360 doldurma modalındaki P2 öğelerinin görünürlük kuralları. Modal
// self-servis rotada yaşar (privileges: []).
//
// Faz 3 / PM-07 — PM AYRICALIK KOŞULLARI KALDIRILDI (`canWritePm` / `canReadPm`).
// Bu iki öğe (bağlam paneli + AI değerlendirme taslağı) tam olarak YÖNETİCİ
// için yazıldı; arkalarındaki uçlar [ModuleAuthorize] TAŞIMIYOR artık:
//   • AI taslağı    → POST v1/performance/ai/feedback-draft  ([Authorize]-only;
//                     AI Plus aboneliği + PM aboneliği + CheckManagerScopeAsync
//                     serviste)
//   • Bağlam paneli → GET  v1/performance/context/...        ([Authorize]-only;
//                     PM aboneliği + İK/doğrudan-rapor kapsamı serviste)
// Kapıyı burada AYRICA uygulamak, düzeltmeyi hedef kitlesine (PM izni olmayan
// amir) ULAŞTIRMAZDI — kapı FE'de kalsaydı BE değişikliği sessizce ölürdü.
// `isManagerRole` koşulu KORUNUR: ikisi de yalnız yönetici formunda anlamlı.
//
// AI Plus (`hasAiModule`) KORUNUR: o bir TENANT ABONELİĞİdir, kullanıcı
// ayrıcalığı değil — servis de aynı kapıyı 409 ile uygular, düğmeyi
// göstermemek kullanıcıya gereksiz hata yaşatmamak içindir.

// Müşteri geri bildirimi (2026-10-28) — öz değerlendirme formundaki "AI ile
// Taslak Hazırla" KALDIRILDI (P7a'da eklenmişti): çalışanın kendi
// değerlendirmesini AI'ya yazdırması zorlama bulundu. Uç da (self-review-draft)
// sunucudan kaldırıldı. Taslak yalnız YÖNETİCİ formunda.
export function canShowAiDraft({ isManagerRole, hasAiModule, openTextCount }) {
  // Açık uçlu soru yoksa taslağın yazılacağı alan da yoktur.
  return Boolean(isManagerRole && hasAiModule && openTextCount > 0);
}

export function canShowContextPanel({ isManagerRole }) {
  return Boolean(isManagerRole);
}
